<template>
  <DialogTemplateWithFooterToolkit
    card_class="categories-card"
    card_text_class="text-start px-0 inputs"
    :data-qa="`${dataQa}-dialog`"
    :dialog="dialog"
    :first_col_class="!multiple && 'col-7 flex align-start'"
    :label="label"
    @close="close">
    <template #activator>
      <v-tooltip
        v-model="tooltip"
        bottom
        content-class="tooltip black--text">
        <template #activator="{ on }">
          <slot
            :items="model"
            name="activator"
            :on="on"
            :open="open">
            <div
              class="width-100"
              :class="{'pointer': true}"
              v-on="maxMultipleCount && (model && model.length || (model_category && model_category.title)) && inputType !== 'textarea' ? on : ''">
              <div
                v-if="inputType==='filter'"
                class="categoryDropDownTree-chip"
                :class="{'disabled': disabled}"
                :data-qa="`${dataQa}-chip`"
                @click="open">
                {{ text }}
              </div>
              <sInput
                v-else-if="inputType === 'textarea'"
                :class="{'active-input': !disabled, 'category-open pointer': true}"
                :clear-forcible="!disabled"
                :data-qa="`${dataQa}-title`"
                :disabled="disabled"
                :error="formItemError"
                :placeholder="label"
                :readonly="!disabled"
                rows="1"
                style="cursor: pointer;"
                type="textarea"
                :value="model_category.title"
                @clear="clearModelSelecting"
                @click.native="open"/>
              <TooltipedBtn
                v-else
                :color="model.length == 5 ? 'grey' : 'var(--black-color)'"
                :data-qa="`btn-${dataQa}-add`"
                :disabled="disabled || (maxMultipleCount && model.length == 5)"
                icon="plus"
                icon_size="10"
                :texted="$t('Common.Add')"
                @click="open"/>
            </div>
          </slot>
        </template>
        <div
          v-if="maxMultipleCount"
          v-dompurify-html="inputType==='filter' ? model.map(el => el.title).join(',  <br/>')
            : multiple ? $t('Tenders.PossibleToAddAdittional') : category ? category.title : label"
          class="text-left h7-text"/>
      </v-tooltip>
    </template>
    <template #card_text>
      <sInput
        key="input-search"
        autofocus
        class="search mt-5"
        clearable
        :data-qa="`${dataQa}-search`"
        :placeholder="$t('Common.EnterCategory')"
        prefix-icon="search"
        :value.sync="search"
        @input="debounceSearching"/>
      <div
        v-if="multiple && multiple_categories.length"
        key="checked-categories"
        class="mt-5">
        <span class="h5-headline black--text ">{{ $t('Purchasing.Selected') }}</span>
        <CategoriesList
          :categories="multiple_categories"
          :clear-selecting="deleteFromSelected"
          :data-qa="`${dataQa}-chips-list`"
          item_key="classificationCode"
          item_name="title"
          :model.sync="multiple_categories"
          multiple
          :used="used"/>
      </div>

      <div
        v-if="inputType !== 'filter'"
        key="filter-block">
        <div v-show="loading || !similarCategories || similarCategories.length > 0">
          <div class="h5-headline pt-5">
            {{ $t('Common.SimilarCategories') }}
          </div>
          <div
            v-if="loading"
            class="my-2">
            <div
              v-for="i in 15"
              :key="i"
              class="skeleton-chip-container mt-1 mr-1"
              :style="`--width: ${Math.floor(Math.random() * (101)) + 100}px;`"/>
          </div>
          <CategoriesList
            v-else
            :categories="similarCategories"
            :clear-selecting="clearSelecting"
            :data-qa="`${dataQa}-chips-list`"
            item_key="classificationCode"
            item_name="title"
            :model.sync="similar_chips"
            :multiple="multiple"
            :multiple_condition="multiple_condition"
            :select-chip="selectChip"
            :used="used"/>
        </div>
      </div>

      <div
        key="found-categories"
        class="sticky pt-8 h4-headline mb-6">
        {{ $t('Common.ThatsWeFound') }}
        <div
          class="grid gap-14 align-center"
          style="grid-template-columns: auto 28px;">
          <sDivider/>
          <sIcon
            class="mr-3"
            type="person"/>
        </div>
      </div>

      <div
        key="categories-tree"
        ref="categories">
        <template
          v-if="loading">
          <div
            v-for="i in 15"
            :key="`categorie-sceleton-${i}`"
            class="skeleton-chip-container mt-1 mr-1"
            :style="`--width: 80%;`"/>
        </template>
        <div
          v-else-if="!categories.length"
          class="notfound-block h5-headline text-center pa-10 secondary__green_chosen">
          {{ $t('Tenders.CategoryNotFound') }}
        </div>
        <v-treeview
          v-else-if="showTree && categories.length"
          id="categories-tree"
          ref="catalog"
          v-model="selectedComputed"
          :data-qa="`${dataQa}-tree`"
          hoverable
          :item-disabled="multiple_condition ? 'locked' : 'used'"
          item-key="classificationCode"
          :items="categories"
          :open.sync="opened"
          :open-all="opeAll"
          open-on-click
          return-object
          selectable
          selected-color="var(--black-color)"
          selection-type="independent"
          transition>
          <template #label="{ item }">
            <b
              v-if="item.service"
              class="h5-headline pr-3">{{ item.title }}
            </b>
            <v-tooltip
              v-else
              bottom
              content-class="">
              <template #activator="{ on }">
                <div
                  class="tree-item pr-3"
                  v-on="item.locked && used && used.length && item.used ? on : ''">
                  <span
                    class="tree-item-title">{{ item.title }}</span>
                </div>
              </template>
              <slot
                :data-qa="`${dataQa}-selectedInAdditionalCategory`"
                :item="item"
                name="used_text">
                {{ (Array.isArray(used) ? $t('Tenders.SelectedInAdditionalCategory') : $t('Tenders.SelectedCategory')) }}
              </slot>
            </v-tooltip>
          </template>

          <template #append="{ item }">
            <div class="mr-3 flex gap-14 align-center">
              <span
                class="secondary__green_not_active--text"
                :data-qa="`${dataQa}-children-length`">
                {{ item.children && item.children.length > 0 ? item.children.length : '' }}</span>
              <span
                class="secondary__green_not_active--text"
                :data-qa="`${dataQa}-participant-count`"
                style="min-width: 38px; text-align: right;">
                {{ item.participantCount ? $n(item.participantCount) : '' }}</span>
            </div>
          </template>
        </v-treeview>
      </div>
    </template>
    <template
      v-if="!multiple && category && category.title"
      #first_col>
      <span key="selected-label">{{ $t('Purchasing.Selected') }}</span>
      <span
        key="selected-category"
        class="pl-2 selected-item"
        :data-qa="`${dataQa}-selected-item`">
        {{ category && category.title }}
      </span>
    </template>
    <template #second_col>
      <sButton
        key="clear-button"
        :data-qa="`btn-${dataQa}-clear`"
        :disabled="apply_disabled"
        type="text"
        @click="clearSelecting">
        {{ $t('Common.Clear') }}
      </sButton>
      <sButton
        key="apply-button"
        :data-qa="`btn-${dataQa}-apply`"
        :disabled="apply_disabled"
        :loading="load_apply"
        @click="save">
        {{ $t(`Common.Apply`) }}
      </sButton>
    </template>
  </DialogTemplateWithFooterToolkit>
</template>

<script>
import CategoriesList from 'components/tenders/CategoriesList.vue'
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import DialogTemplateWithFooterToolkit from 'components/common/dialogs/DialogTemplateWithFooterToolkit.vue'

import SmarttenderApi from '@/api/smarttenderApi'
import formItem from 'mixins/form-item.js'
const api = new SmarttenderApi()

import { debounce } from 'toolkit/utils/util'
export default {
  name: 'CategoryDropDownTree',
  mixins: [formItem],
  props: {
    label: String,
    model: [Object, String, Array],
    inputType: {
      type: String,
      validator: value => ['filter', 'textarea', null].includes(value),
    },
    'return-object': Boolean,
    searched: String,
    multiple: Boolean,
    used: [Array, String],
    apply: Function,
    dataQa: {
      type: String,
      default: 'category-dropdown-tree'
    },
    disabled: Boolean,
    maxMultipleCount: {
      type: Number,
      default: 5
    },
  },
  data() {
    return {
      tooltip: false,
      selected: [],
      categories: [],
      flatCategories: [],
      category: {},
      model_category: {},
      multiple_categories: [],
      similarCategories: [],
      opeAll: false,
      opened: [],
      loading: false,
      load_apply: false,
      dialog: false,
      search: '',
      all_categories: null,
      showTree: true
    }
  },
  computed: {
    selectedComputed: {
      get() {
        return this.selected
      },
      set(val) {
        this.selected = val.filter(i => !i.service)
      }
    },
    multiple_condition() {
      let condition = false
      if (this.maxMultipleCount) {
        condition = this.multiple && this.inputType !== 'filter' && this.multiple_categories.length == this.maxMultipleCount
      }
      let icons = [...document.querySelectorAll('.categories-dialog .v-treeview-node__checkbox')],
        tooltips =  [...document.querySelectorAll('.categories-dialog .disabled-tooltip')]
      if (condition) {
        if (tooltips.length) {
          tooltips.forEach(el => el.style.display = 'block')
        } else if (this.maxMultipleCount) {
          icons.forEach(icon => {
            icon.insertAdjacentHTML('beforebegin', `<div title="${this.$t('Tenders.PossibleToAddAdittional')}"
              class="disabled-tooltip"></div>`)
          })
        }
      } else  {
        tooltips.forEach(el => el.style.display = 'none')
      }
      return condition
    },
    apply_disabled() {
      if (this.multiple && !this.maxMultipleCount) {
        return false
      }
      return  this.inputType !== 'filter' && (this.multiple ? this.multiple_categories.length > this.maxMultipleCount : !this.category.classificationCode)
    },
    similar_chips: {
      get() {
        return this.multiple ? this.multiple_categories : this.category
      },
      set(val) {
        if (this.multiple) {
          this.multiple_categories = val
        } else {
          this.category = val
        }
      }
    },

    text() {
      let selected = this.model
      if (!selected) {
        return
      }
      if (selected?.length > 1) {
        return selected.length + ' ' + this.$t('Tenders.Categories')
      } else if (!selected?.length) {
        return this.$t('Purchasing.All')
      } else {
        return selected[0].title
      }

    },
  },
  methods: {
    open() {
      if (this.disabled) {
        return
      }
      this.$root.$emit('categoryDialog:open')
      setTimeout(() => {
        this.$emit('changeState', true)
        this.dialog = true
        this.start()
        setTimeout(() => {
          let field = document.querySelector('.search input')
          field?.focus()
          field?.select()
        },50)
        this.updateSelected()
        this.hierarchyCallback()
      }, 50)
    },
    start(creating) {
      this.loading = true
      this.loadModel()
      if (!creating &&  (!this.searched || this.model)) {
        this.getFullTree()
          .finally(() => this.loading = false)
      }
    },
    async save() {
      let result
      if (this.multiple) {
        result = this.multiple_categories.map(el => {
          return this.inputType === 'filter' ? {
            classificationCode: el.classificationCode,
            id: el.id,
            title: el.title
          } : el
        })
      } else if (this.returnObject && this.model != this.category) {
        result = this.category
        this.model_category = this.$_.cloneDeep(this.category)
      } else if (!this.returnObject && this.model != this.category.classificationCode) {
        result = this.category.classificationCode
        this.model_category = this.$_.cloneDeep(this.category)
      }
      this.$emit('update:model', result)
      this.$emit('apply', result)
      this.timeout = 0
      if (this.apply) {
        try {
          this.load_apply = true
          await this.apply()
          this.load_apply = false
        } catch (er) {
          this.load_apply = false
          this.$log_error(er)
          this.$show_error_message(er)
          return
        }
      }
      setTimeout(() => {
        this.$_sendFormItemEvent(this.model)
        this.close(true)
      }, 100)
    },
    searching(searched) {
      this.loading = true
      this.categories = []
      this.similarCategories = []

      if (searched) {
        this.opeAll = true
        api.searchClassifications(searched)
          .then(this.hierarchyCallback)
          .finally(() => this.loading = false)
      } else {
        this.getFullTree()
          .finally(() => {
            this.selected = this.multiple_categories

            this.$nextTick(() => {
              this.updateSelected()
              this.loading = false
            })
          })

      }
    },
    debounceSearching: debounce(function (searched) {
      this.searching(searched)
    }, 1000),
    updateSelected() {
      let that = this

      if (this.multiple_categories.length) {
        setTimeout(() => {
          if (!that.$refs.catalog?.nodes) { return }
          Object.entries(that.$refs.catalog?.nodes).forEach(([id, item]) => {
            if (item.isIndeterminate) {
              that.$refs.catalog.updateSelected(id)
            }
          })
        }, 200)
      }
    },
    fetch(code) {
      let that = this
      if (this.multiple) { return }
      return this.$store.dispatch('setSubcategory', this.returnObject && code.classificationCode ? code.classificationCode : code)
        .then((res) => {
          if (!res) { return }
          that.$set(that,'category', res[0] || {})
          that.$set(that,'selected', res)
          that.$set(that,'model_category', res[0] || {})
          if (that.returnObject && !code.classificationCode) {
            that.$emit('update:model', res[0] || {})
          }
        })
    },
    hierarchyCallback(resp) {
      let func = (array) => {
        array?.forEach(item => {
          item.locked = true
          if ( (Array.isArray(this.used) && this.used.find(el => el == item.classificationCode))
            || this.used == item.classificationCode) {
            item.used = true
          } else {
            item.used = false
          }
          if (item?.children === null) {
            this.$delete(item, 'children')
          } else {
            func(item?.children)
          }
          if (this.inputType === 'filter') {
            let selected = this.multiple_categories.findIndex(el => item.id == el.id)
            if ( selected != -1) {
              this.multiple_categories[selected] = item
            }
          }
        })
      }

      let normalize = (array) => {
        array.forEach(item => {
          if (item?.code) {
            this.$set(item, 'classificationCode', item?.code)
            this.$set(item, 'title', `${item?.code} ${item?.title}`)
            this.$delete(item, 'code')
          }
        })
        return array
      }
      if (!resp) {
        const result = func(this.classifications || this.all_categories)
        return result
      }
      if (resp.__typename && resp.__typename == 'ElasticClassificationsGraph') {
        func(resp.classifications)
        let similar = normalize(resp?.classificationsFromTender)
        this.$set(this, 'similarCategories', similar ?? [])

        this.flatCategories = this.flattenTree(resp?.classifications)

        const oldCategoryGroup = []
        this.selected?.forEach(item => {
          if (!this.flatCategories.find(el => el.id == item.id)) {
            oldCategoryGroup.push({
              id: item.id,
              classificationCode: item.classificationCode,
              title: item.title,
              used: item.used,
              locked: item.locked,
              children: []
            })
          }
        })
        let categories = []
        if (oldCategoryGroup?.length) {
          categories.push({
            id: 'oldSelected',
            classificationCode: 'oldSelected',
            title: 'Обрані раніше',
            used: true,
            service: true,
            locked: true,
            children: [...oldCategoryGroup],
          })
          if (resp?.classifications?.length) {
            categories.push({
              id: 'finding',
              classificationCode: 'finding',
              title: 'Результат пошуку',
              used: true,
              service: true,
              locked: true,
              children: [...(resp?.classifications ?? [])],
            })
          }
        } else {
          categories = resp?.classifications
        }

        this.categories = categories

        if (oldCategoryGroup?.length) {
          if (resp?.classifications) {
            this.opened = [...this.opened, ...[{id: 'finding'}]]
          }
          this.opened = [...this.opened, ...[{id: 'oldSelected'}]]
        }
      } else {
        func(resp)
        if (!this.categories.length) {
          this.categories = resp
        }
        this.all_categories = resp
      }
      return resp
    },
    async getFullTree() {
      this.opeAll = false
      if (!this.all_categories?.length) {
        await this.$store.dispatch('treeView')
          .then(this.hierarchyCallback)
      } else {
        this.categories = this.all_categories
      }
    },
    select(val, old) {
      if (this.multiple) {
        let difference = this.$_.difference(old, val)
        if (old?.length && difference?.length == 1 && old.some(it => difference[0].classificationCode == it.classificationCode)) {
          this.similar_chips = this.similar_chips
            .filter(el => !old.find(it => el.classificationCode == it.classificationCode))
        }
        this.$set(this,'multiple_categories', this.$_.uniqBy(this.selected.slice(0).concat(this.similar_chips), 'classificationCode'))
        return
      }
      if (this.selected.length > 1) {
        this.selected.shift()
      }
      this.similar_chips = this.selected.slice(0)

      this.category = this.selected[0] || this.similar_chips
    },
    selectChip(item) {
      if (this.multiple) {
        this.similar_chips.push(item)
        if (this.$refs.catalog?.nodes[item.classificationCode]) {
          this.selected.push(item)
        }
      } else {
        this.$set(this,'similar_chips', item)
        if (this.$refs.catalog?.nodes[item.classificationCode]) {
          this.$set(this,'selected', [item])
        }
      }
    },
    clearModelSelecting() {
      if (this.disabled) {
        return
      }
      this.$emit('update:model', '')
      this.model_category = {}
      this.$emit('clear')
      this.clearSelecting()
      this.refreshTree()
    },
    /** Для перерисовки дерева */
    refreshTree() {
      this.showTree = false
      this.$nextTick(() => {
        this.showTree = true
      })
    },
    clearSelecting(item) {

      if (this.multiple && item && item.id) {
        return this.deleteFromSelected(item)
      }
      this.$set(this,'category', {})

      if (this.used) {
        // used может быть Array или String (см. проп) — .some() существует только у Array,
        // поэтому для String-случая (напр. AddAdditionalCategories прокидывает сюда
        // tenderMutable.classificationCode строкой) сравниваем код напрямую, как и в hierarchyCallback
        let isUsedCode = (code) => Array.isArray(this.used) ? this.used.some(it => it == code) : this.used == code
        let new_selected = this.selected.filter(el => el.classificationCode != this.used
            && !isUsedCode(el.classificationCode))
        if (new_selected) {
          this.$set(this,'selected', this.selected.filter(el => isUsedCode(el.classificationCode)))
        }

        this.$set(this,'multiple_categories', this.multiple_categories.filter(el => isUsedCode(el.id) || isUsedCode(el.classificationCode)))
        return
      }

      this.$set(this,'selected', [])
      this.$set(this,'multiple_categories', [])
    },
    deleteFromSelected(item) {
      this.$set(this,'multiple_categories', this.multiple_categories.filter(el => el.id != item.id))
      if (this.selected.find(el => el.classificationCode == item.classificationCode)) {
        this.$set(this,'selected', this.selected.filter(el => el.classificationCode != item.classificationCode
          && this.$refs.catalog?.nodes[el.classificationCode]))
      }
    },
    loadModel() {
      if (this.multiple) {
        this.$set(this,'selected', this.model.slice(0))
        this.$set(this,'multiple_categories', this.model.slice(0))
      } else if (this.model && typeof this.model == 'object' && Object.keys(this.model).length) {
        this.category = this.model
      } else if (this.model && this.model.length) {
        this.fetch(this.model)
      } else if (!this.model && !this.searched) {
        this.category = {}
        this.selected = []
      } else if (this.searched) {
        this.search = this.searched
        this.searching(this.searched)
      }
    },
    close(safe) {
      if (!safe && this.model) {
        this.loadModel()
        this.selected = []
      }
      this.similarCategories = []
      this.search = ''
      this.opened = []
      this.$root.$emit('categoryDialog:close')
      this.$emit('changeState', false)
      this.dialog = false
    },
    flattenTree(tree) {
      const flatArray = []

      function traverse(node) {
        for (const item of node) {
          const { children, ...rest } = item
          flatArray.push(rest)

          if (children && children.length > 0) {
            traverse(children)
          }
        }
      }

      traverse(tree)
      return flatArray
    }
  },
  mounted() {
    this.start(true)
  },
  watch: {
    selected(val, old) {
      this.select(val,old)
    },
    model(val) {
      if (val && !this.multiple && !this.dialog) {
        this.fetch(val)
      } else if (!val) {
        this.$set(this,'category', {})
        this.$set(this,'model_category', {})
        this.$set(this,'tooltip', false)
      }
    },

  },
  components: {
    TooltipedBtn,
    CategoriesList,
    DialogTemplateWithFooterToolkit
  }
}
</script>
<style lang="scss">

#categories-tree {
  font-size: .875rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: .0071428571em;
  .v-treeview-node__content {
      margin-left: 6px;
  }
  .v-treeview-node__append {
    margin-left: 6px;
  }
}

.categoryDropDownTree-chip {
  cursor: pointer;
  background-color: var(--white-color);
  border-radius: 31px;
  border: 2px solid var(--color-main-green);
  color: var(--text-color);
  height: 40px;
  line-height: 38px;
  outline: none;
  padding: 0 15px;
  text-align: left;
  font-size: 14px;
  overflow: hidden;
  &.disabled {
    opacity: 0.8;
    cursor: default;
    overflow: hidden;
  }
}

.active-input textarea{
  background: var(--white-color) !important;
  border-color: var(--color-main-green) !important;
}
.sFormItem.is-error textarea{
  border-color: var(--secondary__red) !important;
}
.notfound-block {
  border-radius: 10px;
}
.category-open {
  width: 100%;
}
.categories-card {
  .sticky {
    position: sticky;
    top: -20px;
    background: var(--v-main__light_green-base) ;
    background-color: var(--v-main__light_green-base) ;
    z-index: 30;
  }
}
.selected-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
}
.skeleton-chip-container {
  display: inline-block;
  height: 26px;
  width: var(--width);
  background: var(--black-color);
  border-radius: 50px;
  opacity: 0.25;
}

.categories-dialog {
  &_70 {
    height: 70vh;
  }
  .v-treeview-node__root {
    padding: 0;
  }
  .v-treeview-node__toggle,
  .v-treeview-node__root:last-child .v-treeview-node__root:first-child,
  .v-treeview-node--leaf .v-treeview-node__level:first-child {
    display: none
  }
  .tree-item {
    text-align: start;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
 }
  .tree-item-title {
    white-space: normal;
  }
}
.disabled-tooltip {
  position: absolute;
  left: 6px;
  width: 16px;
  height: 16px;
}
</style>
